import '../sass/citrus-hero-carousel.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $citrusHeroCarousels = document.querySelectorAll('.citrus-hero-carousel');

    if (!$citrusHeroCarousels) return;

    $citrusHeroCarousels.forEach($citrusHeroCarousel => {
        const $carousel = $citrusHeroCarousel.querySelector('.citrus-hero-carousel__carousel');

        const initCarousel = () => {
            if (!$carousel) return;

            const swiperScript = document.querySelector('#citrus-theme-swiper-js');

            if (!swiperScript) return;

            swiperScript.addEventListener('load', () => {
                new Swiper($carousel, {
                    keyboard: {
                        enabled: true,
                    },
                    loop: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: false
                    },
                    autoplay: {
                        delay: 2000,
                    },
                    speed: noMotionPreference.matches ? 1000 : 0,
                    allowTouchMove: false,
                });
            });
        };

        initCarousel();
    });
})();
